var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M5 13l4 4L19 7"}));
}

CheckInline.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
